// extracted by mini-css-extract-plugin
export default {"header":"WizardPageHeader_header__SzlfT","backButton":"WizardPageHeader_backButton__B7MrP","backButtonIcon":"WizardPageHeader_backButtonIcon__gXB36"};